import React from "react";

const NoDecisionAddedSection = () => {
  return (
    <div className="no-decision-section">
      <h2 className="no-decision-heading">No Meeting Decisions</h2>
    </div>
  );
};

export default NoDecisionAddedSection;
